import React, { useState, useContext } from "react";

const ResultForm = (props) => {
  const result = props.result;

  const q1 = result != null ? result.quality : null;
  const q2 = result != null ? result.rhythm : null;
  const q3 = result != null ? result.blocks : null;
  const q4 = result != null ? result.pwave : null;
  const q5 = result != null ? result.tWave : null;
  const qqwave = result != null ? result.qwavePatology : null;
  const qpq = result != null ? result.pqInterval : null;
  const qrr = result != null ? result.rrInterval : null;
  const qqt = result != null ? result.qtInterval : null;
  const qstdelta = result != null ? result.stDelta : null;
  const qnote = result != null ? result.note : null;

  const q1Arr = [
    "Good (brak artefaktów, możliwa ocena większości załamków we wszystkich odprowadzeniach)",
    "Acceptable (artefakty ruchowe; możliwość analizy min 3 beatów)",
    "Poor (brak odprowadzeń, zamienione odprowadzenia; możliwość analizy mniej niż 3 beatów)",
  ];
  const q2Arr = [
    "Normal sinus rhythm",
    "Sinus tachycardia",
    "Wandering pacemaker",
    "Sinus arrythmia",
    "SVT",
    "Atrial fibrillation",
    "Atrial flutter",
    "Junctional rythm",
    "Ventrivular tachycardia",
    "Pacer rythm",
    "AVRT",
  ];
  const q3Arr = [
    "1st degree AV block",
    "2nd degree AV block (type 1, Wenckebach)",
    "2nd degree AV block (type 2)",
    "3rd degree AV block",
    "none",
    "other",
  ];
  const q4Arr = [
    "right atrial enlargement",
    "left atrial enlargement",
    "normal",
    "other",
  ];
  const q5Arr = ["positive", "inverted", "isoelectric", "hyperacute/peaked"];
  const qqVal = (qqwave) => {
    if (qqwave != null) {
      if (qqwave == true) {
        return <div>True</div>;
      } else {
        return <div>False</div>;
      }
    } else {
      return null;
    }
  };

  return (
    <div>
      <h3 className="text-center m-3">Quality of ECG recording </h3>
      <h6 className="text-center m-3">{q1Arr[q1]}</h6>

      <h3 className="text-center mt-4">Rytm </h3>
      <h6 className="text-center m-3">{q2Arr[q2]}</h6>

      <h3 className="text-center mt-4">Blocks </h3>
      <h6 className="text-center m-3">{q3Arr[q3]}</h6>

      <h3 className="text-center mt-4">P-Wave </h3>
      <h6 className="text-center m-3">{q4Arr[q4]}</h6>

      <h3 className="text-center mt-4">T-wave </h3>
      <h6 className="text-center m-3">{q5Arr[q5]} </h6>

      <h3 className="text-center mt-4">Q-wave Pathology </h3>
      <h6 className="text-center m-3">{qqVal(qqwave)} </h6>

      <h3 className="text-center mt-4">PQ Interval </h3>
      <h6 className="text-center m-3">{qpq} </h6>

      <h3 className="text-center mt-4">RR Interval </h3>
      <h6 className="text-center m-3">{qrr} </h6>

      <h3 className="text-center mt-4">QT Interval </h3>
      <h6 className="text-center m-3">{qqt} </h6>

      <h3 className="text-center mt-4">ST Delta </h3>
      <h6 className="text-center m-3 ">{qstdelta} </h6>

      <h3 className="text-center mt-4">Notatka </h3>
      <h6 className="text-center m-3">{qnote} </h6>
    </div>
  );
};

export default ResultForm;
